import React, { ReactElement } from 'react';

import { Status } from '@philips-emr/tws-constants';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, isEnumValid } from '@philips-emr/tws-utils';

import { Tooltip } from '../..';
import { TooltipTrigger } from '../../tooltip/constants';

interface EventTokenProps {
  onClick: () => void;
  onContextMenuClick?: () => void;
  onDoubleClick?: () => void;
  status: Status;
  subtitle: string;
  title: string;
}

function EventToken({ status, subtitle, title, onClick, onDoubleClick, onContextMenuClick }: EventTokenProps): ReactElement {
  const elementClasses = {
    'c-event-token': true,
    [`is-${status}`]: isEnumValid(Status, status),
  };

  return (
    <div
      className={classNames(elementClasses)}
      onClick={onClick}
      onContextMenu={onContextMenuClick}
      onDoubleClick={onDoubleClick}
    >
      <Tooltip trigger={TooltipTrigger.HOVER} value={msg(status)}>
        <div className="c-event-token__status" x-contrast="bg" />
      </Tooltip>

      <div className="c-event-token__data">
        <span className="c-event-token__title u-truncate">{msg(title)}</span>
        <span className="c-event-token__subtitle u-truncate">
          {msg(subtitle)}
        </span>
      </div>
    </div>
  );
}

export default EventToken;
